import React from "react";
import { ROLE_NAMES, type PlayerKey } from "../../vowGameLogic";
import { BUTTON_MUTED } from "../uiConstants";
import { ROLE_ICONS, type IconConfig } from "../iconAssets";

type RoleCardProps = {
  playerId: number;
  selfPlayerName?: string;
  selfRole: PlayerKey | null;
  roleLocked: boolean;
  onSelectRole: () => void;
};

const RoleCard: React.FC<RoleCardProps> = ({
  playerId,
  selfPlayerName,
  selfRole,
  roleLocked,
  onSelectRole,
}) => (
  <div className="border-2 border-black bg-[#dcd2b5] p-4">
    <h3 className="text-lg font-semibold text-slate-900">Your Role</h3>
    <div className="mt-3 space-y-3 text-left">
      <InfoRow label="Name" value={selfPlayerName || `Player ${playerId}`} />
      <InfoRow
        label="Role"
        value={selfRole ? ROLE_NAMES[selfRole] : "Not selected"}
        icon={selfRole ? ROLE_ICONS[selfRole] : undefined}
      />
    </div>
    {selfRole ? (
      <p className="mt-3 text-xs font-semibold uppercase tracking-wide text-emerald-700">
        {roleLocked
          ? "Role locked for this session."
          : "Select your role to begin playing."}
      </p>
    ) : (
      <button type="button" onClick={onSelectRole} className={`mt-4 w-full ${BUTTON_MUTED}`}>
        Select Role
      </button>
    )}
  </div>
);

type InfoRowProps = {
  label: string;
  value: string;
  icon?: IconConfig;
};

const InfoRow: React.FC<InfoRowProps> = ({ label, value, icon }) => (
  <div className="border border-black bg-[#faf3e2] px-3 py-2 flex flex-row justify-between items-center">
    <div className="flex flex-col">
      <p className="text-xs uppercase tracking-wide text-slate-600">{label}</p>
      <p className="text-base font-semibold text-slate-900">{value}</p>
    </div>
    {icon && (
      <img
        src={icon.src}
        alt={icon.alt}
        className="h-8 w-8 min-w-[1.5rem] object-contain"
      />
    )}
  </div>
);

export default RoleCard;
